import { IUseFareChangeDetailsResult, getTripFareBreakup, usePartnerFeatures } from 'obt-common';
import { useSelector } from '@xstate/react';
import { useFareChangeDetailsV2 } from 'obt-common/hooks/Flights/useFareChangeDetailsV2';
import useRetryPaymentService from '../xstate/useRetryPaymentService';
import useAirSelectedItineraryManager from './useAirSelectedItineraryManager';
import useGetPnr from './useGetPnr';

export default function useGetFareChangeDetails(): IUseFareChangeDetailsResult | null {
  const retryPaymentService = useRetryPaymentService();

  const pnr = useGetPnr();

  const revalidateItineraryResponse = useSelector(
    retryPaymentService,
    (state) => state.context.retryPaymentRevalidateResponse,
  );

  const airSelectedItineraryResponseManager = useAirSelectedItineraryManager();

  const { features } = usePartnerFeatures();
  const { showServiceFeeTax } = features;

  const flightFareBreakup = getTripFareBreakup({ pnr, showServiceFeeTax: showServiceFeeTax ?? false });

  const fareBreakup = {
    totalBaggagePrice: flightFareBreakup.totalBaggagePrice,
    totalSeatPrice: flightFareBreakup.totalSeatPrice,
    serviceFees: flightFareBreakup.serviceFees,
    totalAmount: flightFareBreakup.totalAmount,
  };

  const fareChangeDetails = useFareChangeDetailsV2({
    revalidateResponse: !revalidateItineraryResponse ? null : revalidateItineraryResponse,
    fareBreakup,
    airSelectedItineraryResponseManager,
  });

  return fareChangeDetails;
}
